import { Directive, ElementRef } from '@angular/core';
import { DatatablePage } from '@app/shared/datatable-page';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Directive({
  selector: '[portalTable]',
  standalone: false,
})
export class DataTableDirective {
  get element() {
    return this.el;
  }

  get page$(): Observable<DatatablePage<any>> {
    return this.pageSubject.asObservable().pipe(filter((page) => page != null));
  }

  set page(value: DatatablePage<any>) {
    this.pageSubject.next(value);
  }

  private pageSubject = new BehaviorSubject<DatatablePage<any>>(null);

  constructor(private el: ElementRef) {}
}
